/* Loveleen Sari Palace — accessibility patch for the Apntly booking widget.
   Added 3 August 2026.

   WHY THIS EXISTS
   The booking widget is a third-party iframe. Three problems, none of them ours:
     1. The iframe has no title, so assistive tech announces it as an unnamed frame.
     2. Its month back/forward arrows use role="button" with no accessible name AND
        no tabindex — so they are unlabelled and unreachable by keyboard. A keyboard
        user cannot move to next month to book.
     3. The frame document has no lang and no title.

   This patches all three from the parent page, which is only possible because the
   frame happens to be same-origin.

   THIS IS A SPLINT, NOT A REPAIR. It depends on Apntly's class names (.vc-arrow,
   .is-left, .is-disabled — they use v-calendar). If Apntly reships their front end
   these selectors may stop matching and the patch will quietly do nothing. It is
   written to fail silently rather than break the booking page, which means silence
   is the failure mode — re-test the booking page after any Apntly update.
   The real fix is Apntly labelling their own controls; a bug report has been sent.
*/
(function () {
  'use strict';

  function labelArrows(doc) {
    var arrows = doc.querySelectorAll('.vc-arrow');
    if (!arrows.length) return false;

    Array.prototype.forEach.call(arrows, function (a) {
      var isBack = a.classList.contains('is-left');
      var label = isBack ? 'Previous month' : 'Next month';
      if (a.getAttribute('aria-label') !== label) a.setAttribute('aria-label', label);

      if (a.classList.contains('is-disabled')) {
        a.setAttribute('aria-disabled', 'true');
        a.removeAttribute('tabindex');
      } else {
        a.removeAttribute('aria-disabled');
        if (a.getAttribute('tabindex') === null) a.setAttribute('tabindex', '0');
      }

      /* role="button" does not give you Enter/Space for free — only real buttons
         get that. Without this the arrows focus but do nothing when activated. */
      if (!a.hasAttribute('data-lsp-kbd')) {
        a.setAttribute('data-lsp-kbd', '1');
        a.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            a.click();
          }
        });
      }
    });
    return true;
  }

  function patch() {
    var f = document.querySelector('#apntly-booking-iframe');
    if (!f) return false;

    if (!f.getAttribute('title')) f.setAttribute('title', 'Appointment booking calendar');

    var doc;
    try {
      doc = f.contentDocument;
    } catch (e) {
      return true; /* went cross-origin — the title above is all we can do */
    }
    if (!doc || !doc.body) return false;

    if (!doc.documentElement.getAttribute('lang')) doc.documentElement.setAttribute('lang', 'en');
    if (!doc.title) doc.title = 'Appointment booking';

    var ok = labelArrows(doc);

    /* The calendar re-renders when the month changes, which wipes our attributes.
       Watch for that and re-apply. Filtered to class changes so our own
       aria-* writes cannot retrigger it. */
    if (ok && !doc.__lspA11yObserver) {
      doc.__lspA11yObserver = new MutationObserver(function () { labelArrows(doc); });
      doc.__lspA11yObserver.observe(doc.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['class']
      });
    }
    return ok;
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var done = false;
    try { done = patch(); } catch (e) { done = false; }
    if (done || tries > 60) clearInterval(timer); /* give up after ~30s */
  }, 500);
})();
